export * from "./amulet.svg";
export * from "./heart.svg";

export const z = 7;
